import {ChangeDetectorRef, Component, OnInit, ViewContainerRef} from '@angular/core';
import {ConfigurationService} from '../configuration.service';
import {NotificationPopupService} from '../../shared/notification-popup/services/notification-popup.service';
import {MarketsConfigResponse} from '../shared/models/markets-config.model';

// Thin router: fetches once, then hands the response to whichever mode component applies -
// neither RangesMarketsComponent nor ServiceMarketsComponent re-fetches on init. Loading/error
// state lives here since it has to exist before either child component does.
@Component({
    selector: 'app-markets',
    templateUrl: './markets.component.html',
    styleUrls: ['./markets.component.scss']
})
export class MarketsComponent implements OnInit {
    public mode: 'ranges' | 'services' | null = null;
    public response: MarketsConfigResponse | null = null;

    public loaded = false;
    public loadError = false;

    constructor(private configurationSvc: ConfigurationService,
                private notificationPopupSvc: NotificationPopupService,
                private viewContainerRef: ViewContainerRef,
                private cdr: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.configurationSvc.getMarketsConfig().subscribe(response => {
            this.mode = response.mode;
            this.response = response;
            this.loaded = true;
            this.cdr.detectChanges();
        }, error => {
            console.error(`Error retrieving markets config ${error}`);
            this.loaded = true;
            this.loadError = true;
            this.notificationPopupSvc.displayPageNotification(this.viewContainerRef, {
                notificationType: 'error',
                message: 'Failed to load market configuration.'
            });
            this.cdr.detectChanges();
        });
    }
}
